<template>
  <PublicPopup
    ref="PopupRef"
    background="transparent"
    :border-size="0"
    :padding="0"
    :closeable="false"
    style="z-index: 3000"
    @close="isLiveLoading = false"
  >
    <template #content>
      <div class="live-popup">
        <img
          :src="getImageUrlWithCDN_TEST('/home/football_banner.webp')"
          class="football-banner"
          @click="isLiveLoading = true"
        />

        <div class="channe-group-container">
          <div class="channe-group-popover chxy-row-c-c" @click="channeShow = true">
            <span class="text">{{ channeChecked.name }}</span>
            <van-icon :name="`arrow-${!channeShow ? 'down' : 'up'}`" class="icon" />
          </div>
          <div v-show="channeShow" class="channe-group">
            <van-radio-group v-model="channeChecked.name">
              <van-cell-group inset>
                <van-cell
                  v-for="(item, index) in channelList"
                  :key="index"
                  :title="item.name"
                  clickable
                  @click="handleChannelChange(item)"
                >
                  <template #right-icon>
                    <van-radio :name="item.name" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>

        <img
          v-show="isLiveLoading"
          :src="getImageUrlWithCDN_TEST('/home/football_loading.gif')"
          class="football-banner-loading"
        />
        <div
          class="close-icon"
          @click.stop="
            ;() => (isLiveLoading = false)
            PopupRef.close()
          "
        ></div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const PopupRef = ref(null)

const isLiveLoading = ref(false)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const close = () => {
  isLiveLoading.value = false
  PopupRef.value.close()
}

const channeShow = ref(false)
const channelList = ref([
  { id: 1, name: t('home-ad-popup-live-popup.canal1') },
  { id: 2, name: t('home-ad-popup-live-popup.canal2') },
])
const channeChecked = reactive({
  ...channelList.value[0],
})
const handleChannelChange = (item) => {
  channeChecked.id = item.id
  channeChecked.name = item.name
  channeShow.value = false
  isLiveLoading.value = true

  setTimeout(() => {
    isLiveLoading.value = false
  }, 5000)
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.live-popup {
  position: relative;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
  }

  .football-banner {
    width: 100%;
    height: auto;
  }

  .football-banner-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 36px;
  }
}

.channe-group-container {
  position: absolute;
  right: 40px;
  bottom: 11px;

  .channe-group-popover {
    gap: 1px;
    padding: 3px 8px;
    background-color: rgba(0, 0, 0, 0.2);
    border: solid thin rgba(255, 255, 255, 0.4);
    border-radius: 50px;
    font-size: 11px;
    color: #ffffff;
  }

  .channe-group {
    position: absolute;
    top: -74px;
    right: 0;

    .van-radio-group {
      background-color: transparent;

      .van-cell-group {
        background-color: rgba(0, 0, 0, 0.7);
        border: solid thin rgba(255, 255, 255, 0.4);
        border-radius: 5px;

        .van-cell + .van-cell {
          border-top: 1px solid var(--language-popup-border-bottom);
        }
        .van-cell {
          padding: 6px 8px;
          width: 120px;
          background-color: transparent;
          font-size: 12px;
          color: #ffffff;

          :deep() {
            .van-radio__icon {
              font-size: 16px;
            }
          }
        }
      }
    }

    :deep(.van-radio__icon--checked .van-icon) {
      color: #333333;
      background-color: #ffffff;
      border-color: #ffffff;
    }
  }
}
</style>
